import { endpoints } from 'endpoints.config';
import axios from 'api';

import { ResetPasswordPost } from './models';

export type ApiReturn<T = any> = {
  response: T | null;
  errors: Error[] | null;
};

export const PostResetPassword = async (
  payload: ResetPasswordPost
): Promise<ApiReturn> => {
  try {
    const res = await axios.post(
      endpoints.forgottenPassword.resetPassword,
      payload
    );
    if (res.data.status === '1') {
      return {
        response: res.data.details,
        errors: null,
      };
    } else {
      return {
        response: res.data.details,
        errors: res.data.errors,
      };
    }
  } catch (err: any) {
    return {
      response: null,
      errors: err,
    };
  }
};
